import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'workShiftHours', standalone: false })
export class WorkShiftHoursPipe implements PipeTransform {
  moment = require('moment');

  transform(millis: any): any {
    let time = '';
    let timeObj = millis ? this.moment.duration(millis) : undefined;

    if (typeof timeObj === 'object') {
      let hours = timeObj.hours();
      let minutes = timeObj.minutes();

      time = (hours ? hours : 0) + (minutes ? (minutes < 10 ? '-0' + minutes : '-' + minutes) : '');
    }

    return time;
  }
}

@Pipe({ name: 'workShiftHoursOnly', standalone: false })
export class WorkShiftHoursOnlyPipe implements PipeTransform {
  moment = require('moment');

  transform(millis: any): any {
    let time = '';
    let timeObj = this.moment.duration(millis) || undefined;

    if (typeof timeObj === 'object') {
      let days = timeObj.days();
      let hours = days * 24 + timeObj.hours();

      time = hours ? hours : 0;
    }

    return time;
  }
}
